export default function Footer() {
  return (
    <footer 
      className="py-16 text-white"
      style={{ background: 'linear-gradient(180deg, #1a1f3a 0%, #000000 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-8">
          {/* Left: Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-3">グルメスワイプ</h3>
            <p className="text-sm text-gray-400">
              スワイプで、次の店が決まる。Ver.0 2026/3/27 予定。
            </p>
          </div>

          {/* Right: CTA Button */}
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#EDD92A] text-black font-bold px-6 py-3 rounded-lg hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            LINEで先行登録
          </a>
        </div>

        {/* Middle Section: Links */}
        <div className="flex flex-wrap gap-6 mb-8 text-sm">
          <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            プライバシーポリシー
          </a>
          <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            利用規約
          </a>
          <a href="https://lin.ee/PJ9odjt" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            お問い合わせ（LINE）
          </a>
        </div>

        {/* Bottom Section: Copyright */}
        <div className="border-t border-gray-700 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © 2025 グルメスワイプ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-500 hover:text-gray-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
